import * as React from "react";

function SvgDocs(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.97 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M22.69 5.15A1.26 1.26 0 0124 6.43v16.29a1.26 1.26 0 01-1.31 1.25H9.85a1.28 1.28 0 01-1.29-1.28v-3.83H1.29a1.21 1.21 0 01-.91-.37 1.25 1.25 0 01-.38-.91v-9A3.07 3.07 0 01.27 7.4a3.13 3.13 0 01.64-1L6.37.91a3.31 3.31 0 011-.64 3 3 0 011.19-.3h5.57a1.25 1.25 0 01.87.41 1.23 1.23 0 01.37.91v4.39a3.48 3.48 0 011.72-.53zM9.47 11.52l4.23-4.23V1.72H8.56v5.57a1.26 1.26 0 01-1.28 1.28H1.71v8.58h6.85v-3.43a3.07 3.07 0 01.27-1.18 3.13 3.13 0 01.64-1.02zM6.85 2.86l-4 4h4zm15.41 19.43V6.86h-5.13v5.57a1.3 1.3 0 01-1.29 1.29h-5.56v8.57zM15.41 7.97l-4 4h4z" />
    </svg>
  );
}

const MemoSvgDocs = React.memo(SvgDocs);
export default MemoSvgDocs;
